// import ProductSelect from './ProductSelect';
// import CustomerInfo from './CustomerInfo';
import NavigatorBar from './NavigatorBar';
// import CategorySelect from './CategorySelect';
// import CabinSelect from './CabinSelect';
// import PricingSummary from './PricingSummary';
import RoomQuantity from './RoomQuantity';
import RoomGuestQuantity from './RoomGuestQuantity';
import RoomCategory from './RoomCategory';
import RoomChoose from './RoomChoose';
import ImageGallery from './ImageGallery';
import ModalContent from './ModalContent';
import CustomizeOffer from './CustomizeOffer';
import CustomizePreference from './CustomizePreference';
import ReviewRoom from './ReviewRoom';
import GuestInfo from './GuestInfo';
import ConfirmPayment from './ConfirmPayment';



export default {  NavigatorBar,  ConfirmPayment, RoomQuantity, RoomGuestQuantity, RoomCategory, RoomChoose, ImageGallery, ModalContent, CustomizeOffer, CustomizePreference, ReviewRoom, GuestInfo }